import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="spinner">
        <svg viewBox="0 0 50 50">
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#16D7DB" />
              <stop offset="100%" stopColor="#1D364C" />
            </linearGradient>
          </defs>
          <circle
            cx="25"
            cy="25"
            r="20"
            fill="none"
            stroke="url(#gradient)"
            strokeWidth="9"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <h1 className="title">Generando la mejor cuota</h1>
      <p>En unos segundos estará listo</p>
    </div>
  );
};

export default LoadingScreen;
